export const setCurrentTool = "editor/tools/SET_CURRENT";
export const setZoomScaleModifier = "editor/tools/SET_ZOOM_SCALE_MODIFIER";
export const setColorValue = "editor/tools/SET_COLOR_VALUE";
